var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMajesticonsAnalyticsLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33317 14.666V10.0827M10.9998 14.666V7.33268M14.6665 14.666V12.8327M16.4998 3.66602H5.49984C5.01361 3.66602 4.54729 3.85917 4.20347 4.20299C3.85966 4.5468 3.6665 5.01312 3.6665 5.49935V16.4993C3.6665 16.9856 3.85966 17.4519 4.20347 17.7957C4.54729 18.1395 5.01361 18.3327 5.49984 18.3327H16.4998C16.9861 18.3327 17.4524 18.1395 17.7962 17.7957C18.14 17.4519 18.3332 16.9856 18.3332 16.4993V5.49935C18.3332 5.01312 18.14 4.5468 17.7962 4.20299C17.4524 3.85917 16.9861 3.66602 16.4998 3.66602Z",
    stroke: "#77787B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajesticonsAnalyticsLine);
export default __webpack_public_path__ + "static/media/majesticons_analytics-line.eb44d1f5332ad92c09693047af54c7cc.svg";
export { ForwardRef as ReactComponent };